var WebSocketClass = /** @class */ (function () {
    function WebSocketClass(socketUrl) {
        this.webSocket = new WebSocket(socketUrl);
    }
    WebSocketClass.prototype.onOpen = function (fnc) {
        this.webSocket.onopen = function (event) { return fnc(event); };
    };
    WebSocketClass.prototype.onClose = function (fnc) {
        this.webSocket.onclose = function (event) { return fnc(event); };
    };
    WebSocketClass.prototype.onMessage = function (fnc) {
        this.webSocket.onmessage = function (event) { return fnc(event); };
    };
    WebSocketClass.prototype.onError = function (fnc) {
        this.webSocket.onerror = function (event) { return fnc(event); };
    };
    return WebSocketClass;
}());
export default WebSocketClass;



//////////////////
// WEBPACK FOOTER
// ./src/utils/WebSocketClass.ts
// module id = null
// module chunks = 